export interface LiveDraw {
  readonly drawNo: number;
  readonly drawDate: string;
  readonly numbers: readonly number[];
  readonly bonusNumber: number;
  readonly winnerCount: number;
  readonly firstPrizeAmount: number;
  readonly prizes: readonly { readonly rank: number; readonly winnerCount: number; readonly totalAmount: number; readonly perWinnerAmount: number }[];
}

interface DrawDescriptor { readonly url: string }
interface DrawArtifact {
  readonly draw: {
    readonly drawNo: number;
    readonly drawDate: string;
    readonly numbers: readonly number[];
    readonly bonusNumber: number;
    readonly prizes: readonly { readonly rank: number; readonly winnerCount: number; readonly totalAmount: number; readonly perWinnerAmount: number }[];
  }
}

/** Public, signed Lotto result only. No user identity or browser location is sent. */
export async function loadLatestLiveDraw(): Promise<LiveDraw> {
  const descriptor = await fetch("/api/lotto/draws/latest", { headers: { Accept: "application/json" } });
  if (!descriptor.ok) throw new Error("latest_draw_unavailable");
  const { url } = await descriptor.json() as DrawDescriptor;
  const name = new URL(url).pathname.split("/").pop();
  if (!name || !/^lotto-draw-[1-9][0-9]*-[0-9a-f]{12}\.json$/.test(name)) throw new Error("invalid_draw_descriptor");
  const artifact = await fetch(`/api/lotto-bundles/${name}`, { headers: { Accept: "application/json" } });
  if (!artifact.ok) throw new Error("draw_artifact_unavailable");
  const response = await artifact.json() as DrawArtifact;
  const first = response.draw.prizes.find(prize => prize.rank === 1);
  if (!first || response.draw.numbers.length !== 6) throw new Error("invalid_draw_artifact");
  return { ...response.draw, winnerCount: first.winnerCount, firstPrizeAmount: first.perWinnerAmount, prizes: response.draw.prizes };
}
